import { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Tabs, Tab, Tooltip, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { CreateServiceBundleForm } from './create-bundle/create-service-bundle.form';
import { ServiceBundles } from './service-bundles.component';
import { EditServiceBundleForm } from './create-bundle/edit-service-bundle.form';
import { ServiceBundle } from '../../../../models/service-bundle';
import { TabPanel } from '../../../../components/tab-panel';

interface ServiceBundleDialogProps {
  officeID: number;
  open: boolean;
  onClose: () => void;
  refetch: () => void;
  value: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
  setEditItem: React.Dispatch<React.SetStateAction<ServiceBundle | undefined>>;
  editItem: ServiceBundle | undefined;
}

export const ServiceBundleDialog = ({
  officeID,
  open,
  onClose,
  refetch,
  value,
  setValue,
  editItem,
  setEditItem,
}: ServiceBundleDialogProps) => {
  const handleClosed = () => {
    onClose();
  };

  const handleSaveCompleted = () => {
    // setValue('view');
    refetch();
    onClose();
  };
  const handleEditCompleted = () => {
    refetch();
    setEditItem(undefined);
    // setValue('view');
    onClose();
  };
  const handleEditClick = (item: ServiceBundle) => {
    setEditItem(item);
    setValue('edit');
  };

  const handleTabsChange = (event: any, value: any) => {
    setValue(value);
  };

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={'xl'}
      // onClose={handleClosed}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
    >
      <DialogTitle id="dialog-title" sx={{ p: 0, m: 0 }}>
        <Tabs value={value} onChange={handleTabsChange}>
          <Tab value="create" label={<div>CREATE BUNDLE</div>} hidden={!!editItem} />
          <Tab value="edit" label={<div>EDIT BUNDLE</div>} hidden={!editItem} />
        </Tabs>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClosed}
        sx={{
          position: 'absolute',
          right: 10,
          top: 3,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Tooltip title={<Typography variant="body1">Close</Typography>}>
          <CloseIcon />
        </Tooltip>
      </IconButton>
      <DialogContent dividers className="popupDilog">
        {/* <TabPanel selectedValue={value} value="view" className="bundlePopupMaxHeight">
          <ServiceBundles officeID={officeID} onEdit={handleEditClick} />
        </TabPanel> */}
        <TabPanel selectedValue={value} value="create">
          <CreateServiceBundleForm officeID={officeID} onCompleted={handleSaveCompleted} refetch={refetch} />
        </TabPanel>
        {editItem && (
          <TabPanel selectedValue={value} value="edit">
            <EditServiceBundleForm
              officeID={officeID}
              onCompleted={handleEditCompleted}
              serviceBundleID={editItem.typeID}
              refetch={refetch}
            />
          </TabPanel>
        )}
      </DialogContent>
    </Dialog>
  );
};
